import type { SVGProps } from "react";

import "./ContactSuccessIcon.css";

export const ContactSuccessIcon = (props: SVGProps<SVGSVGElement>) => (
  <div className="svg-container">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={100}
      height={100}
      aria-hidden="true"
      className="ft-green-tick"
      viewBox="0 0 48 48"
      {...props}
    >
      <circle cx={24} cy={24} r={22} fill="#5bb543" className="circle" />
      <path
        fill="none"
        stroke="#FFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={6}
        d="m14 27 5.917 4.917L34 17"
        className="tick"
      />
    </svg>
  </div>
);
